import axios from "axios";

export const persistStateToLocalStorage = (state) => {
  try {
    const serializedState = JSON.stringify({ authReducer: state.authReducer });
    localStorage.setItem("state", serializedState);
  } catch (e) {
    console.log(e);
  }
};

export const restoreStateFromLocalStorage = () => {
  try {
    const serializedState = localStorage.getItem("state");
    if (serializedState === null) {
      return undefined;
    }
    // Get and parse the persisted state object.
    let persistedState = JSON.parse(serializedState);
    let parsedState = Object.assign({}, persistedState, {
      authReducer: Object.assign({}, persistedState.authReducer, {
        isFetching: false,
      }),
    });
    // Inject jwt token as Authorization header
    // axios.defaults.headers.common["X-Auth-Token"] = parsedState.authReducer.token;
    axios.defaults.headers.common["Authorization"] = "Bearer " + parsedState.authReducer.token;
    return parsedState;
  } catch (e) {
    console.log(e);
    return undefined;
  }
};
